(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-localization-select]');
  if (!select || !select.form) return;
  select.form.submit();
});

  } catch(e) { console.error(e); }
})();
})();
